import { createFileRoute } from '@tanstack/react-router'
import { PERMISSION_ROLES } from '../../../../../src/constants/premissions'
import { riskReportParamsSchema, riskReportSearchSchema } from '../../../../../src/schemas/routeSchemas'
import { requirePermission } from '../../../../../src/utils/routePermissions'

export const Route = createFileRoute('/v5/risk/report/$mmsi')({
  validateSearch: (search) => riskReportSearchSchema.parse(search),
  params: {
    parse: (params) => riskReportParamsSchema.parse(params),
  },
  loaderDeps: () => ({}),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  staticData: {
    englishAllowed: true,
    permissionRequired: PERMISSION_ROLES.V5_RISK_REPORT,
  },
})
